import { render, staticRenderFns } from "./inviteSatisfactionQuestionnaire.vue?vue&type=template&id=18e16fd4&scoped=true"
import script from "./inviteSatisfactionQuestionnaire.vue?vue&type=script&lang=js"
export * from "./inviteSatisfactionQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e16fd4",
  null
  
)

export default component.exports